import url from './url';

async function handleAddress(cep) {

    let data = await fetch(`https://viacep.com.br/ws/${cep}/json/`, {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        method: 'get'
    }).then(res => res.json());

    return data;

}

export { handleAddress }